// Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { HeaderNav } from 'components/SharedComponents/nav-bar/header-nav';


export class Header extends Component {
    constructor(props) {
        super(props);
    }

    headerNav(header) {
        if (header.isActive !== undefined && header.isActive === false) {
            return null;
        }
        const headerNavProps = {
            isSignedIn: this.props.isSignedIn,
            isOrganizer: this.props.isOrganizer,
            channelKey: this.props.myChannelKey,
            navbarBackgroundClasses: header.navbarBackgroundClasses,
            menuItemTextClasses: header.menuItemTextClasses,
            showAlternateLogo: header.showAlternateLogo,
            showMenuOverlay: this.props.showMenuOverlay,
            showSearchInputOverlay: this.props.showSearchInputOverlay,
            showSearch: header.showSearch && this.props.launchDarkly.search.enableSearch,
            searchBarColor: header.searchBarColor,
            searchQuery: header.searchQuery
        };
        return (<HeaderNav
          {...
            headerNavProps
            }
        />);
    }

    theme(header) {
        const style = {
            backgroundColor: header.channelTheme !== 'default' ? header.channelTheme : '#333b46'
        };
        if (header.imgsrc) {
            return (<div className="header-img-div">
                <img className="header-img" src={header.imgsrc} alt="Channel Banner" />
            </div>);
        }
        if (header.channelTheme) {
            return (<section className={classNames('header-theme')} style={style} />);
        }
        return null;
    }

    render() {
        const { header } = this.props;
        return (
            <div className={`header my-catalog-page-mainnav-header ${header.classes || ''}`}>
                {this.headerNav(header)}
                {this.theme(header)}
                <div className="content-container"> {header.content} </div>
            </div>
        );
    }
}

Header.propTypes = {
    header: PropTypes.object.isRequired,
    isOrganizer: PropTypes.bool.isRequired,
    isSignedIn: PropTypes.bool.isRequired,
    myChannelKey: PropTypes.string,
    launchDarkly: PropTypes.object,
    showMenuOverlay: PropTypes.func,
    showSearchInputOverlay: PropTypes.func
};


export default connect((state) => {
    return (
        {
            header: state.header
        }
    );
})(Header);



// WEBPACK FOOTER //
// ./src/components/SharedComponents/header.js